var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgWhatsApp = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeMiterlimit: 2.61,
    strokeWidth: 1.5,
    d: "M78.957 49.805c0-.07 0-.139.013-.206.012-.068 0-.189.012-.284 0-.164.013-.33.018-.503V47.283c0-.135 0-.294-.013-.44v-.299c0-.178-.017-.36-.03-.538v-.183a26.918 26.918 0 0 0-.052-.641v-.063a31.021 31.021 0 1 0-55.731 21.473l-.028.133-.754 3.376-.252 1.091-1.097 4.963a1 1 0 0 0 1.277 1.17l4.848-1.525 2.17-.681 2.347-.737a31.023 31.023 0 0 0 47.26-24.577h.012Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M62.047 26.688a24.486 24.486 0 0 1 2.632 1.814M73.188 42.187c-1.56-5.299-3.72-8.993-6.352-11.728"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M32.988 33.107c-1.632 1.888-2.205 4.274-1.983 6.9-.966 10.49 14.874 26.948 25.223 25.948 3.268.287 6.204-.767 8.263-3.71.932-1.916.719-3.047.427-3.625-.85-1.692-6.453-3.542-8.283-4.286-1.083-.443-3.52 1.174-4.19 2.066-.672.892-1.835.272-1.835.272-2.63-1.318-9.603-9.002-10.661-11.755 0 0-.503-1.22.445-1.8.947-.58 2.797-2.853 2.463-3.977-.334-1.123-3.017-8.242-3.017-8.242s-.91-1.539-4.105-.347a10.216 10.216 0 0 0-2.752 2.556h.005Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: "var(--color-neutral-70)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M37.304 33.464c-1.896.969-3.35 2.907-3.35 5.328"
  }));
};
export default SvgWhatsApp;